import { useCallback, useEffect } from 'react';
import client from '../clients/client';

export const useLoggedIn = () => {
  const checkIfAuth = useCallback(async () => {
    let response = await client.get('/is-auth');
  }, []);

  useEffect(() => {
    checkIfAuth();
  }, [checkIfAuth]);
};
